import { render, staticRenderFns } from "./CompanyProfile5.vue?vue&type=template&id=159b0ff3&scoped=true&"
import script from "./CompanyProfile5.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile5.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile5.vue?vue&type=style&index=0&id=159b0ff3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b0ff3",
  null
  
)

export default component.exports